import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import {
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addParticipants, editParticipants } from "store/actions";
import { fetchLanguageList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ParticipantsAddEditModal = (props) => {
  const {
    modal,
    toggle,
    isEdit,
    itemData,
    SetItemData,
    fetchParticipantsListData,
    batchId,
  } = props;
  const [participantsData, setParticipantsData] = useState();
  const [languageList, setLanguageList] = useState();
  const [scoreDate, setScoreDate] = useState(null);
  const { state } = useLocation();

  const { error, success, loading, editLoading } = useSelector((state) => ({
    loading: state.Batches.loading,
    error: state.Batches.error,
    success: state.Batches.success,
    editLoading: state?.Batches?.editLoading,
  }));
  const dispatch = useDispatch();
  const utcDate = new Date(itemData?.scored_date); // UTC Date
  const localDate =itemData?.scored_date? new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000):null
  useEffect(() => {
    setParticipantsData(itemData);
    // setScoreDate(itemData?.scored_date);
  }, [itemData]);

  // fetch language
  const fetchLanguageLists = async () => {
    const listLang = await fetchLanguageList();
    setLanguageList(listLang?.data);
  };

  useEffect(() => {
    fetchLanguageLists();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstname: participantsData?.firstname || "",
      lastname: participantsData?.lastname || "",
      useremail: participantsData?.useremail || "",
      phone_number: participantsData?.phone_number || "",
      organization_code: participantsData?.organization_code || "",
      language_id:
        participantsData?.language_id || (languageList && languageList[0]?.id),
      scored_date: participantsData?.scored_date || "",
      report_name: participantsData?.report_name || "",
      password: participantsData?.password || "",
      is_active: participantsData?.is_active || "Y",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required(props.t("Please Enter First Name")),
      lastname: Yup.string().required(props.t("Please Enter Last Name")),
      // useremail: Yup.string().required(props.t("Please Enter Usermail")),
      // phone_number: Yup.string().required(props.t("Please Enter Phone Number")),
      // organization_code: Yup.string().required(props.t("Please Enter Organization Code")),
      language_id: Yup.string().required(props.t("Please Enter Language")),
      // scored_date: Yup.string().required(props.t("Please Enter Scored Date")),
      // report_name: Yup.string().required(props.t("Please Enter Report Name")),
      is_active: Yup.string().required(props.t("Please Enter Text Status")),
    }),
    onSubmit: (values, { resetForm }) => {
      values = {
        ...values,
        scored_date: scoreDate!=null? new Date(Date.UTC(
          scoreDate.getFullYear(),
          scoreDate.getMonth(),
          scoreDate.getDate(),
          scoreDate.getHours(),
          scoreDate.getMinutes()
        )):(itemData?.scored_date || ""),
      };

      if (isEdit) {
        values = {
          ...values,
          batch_id: batchId,
        };
        dispatch(
          editParticipants(values, participantsData?.id, (res) => {
            if (res.status === "success") {
              toastr.success(res.message);

              resetForm({
                firstname: "",
                lastname: "",
                useremail: "",
                phone_number: "",
                organization_code: "",
                language_id: "",
                scored_date: "",
                report_name: "",
                is_active: "",
              });
              fetchParticipantsListData();
              setScoreDate();
              toggle();
            } else {
              toastr.error(res.message);
              // toggle()
            }
          })
        );
      } else {
        dispatch(
          addParticipants(values, batchId, (res) => {
            if (res?.status === "success") {
              resetForm({
                firstname: "",
                lastname: "",
                useremail: "",
                phone_number: "",
                organization_code: "",
                language_id: "",
                scored_date: "",
                report_name: "",
                is_active: "",
              });
              fetchParticipantsListData();
              setScoreDate();
              toastr.success(res.message);
              toggle();
            } else {
              toastr.error(res.message);
              setScoreDate();
              // toggle()
            }
          })
        );
      }
    },
  });

  const onResetFormData = () => {
    validation.resetForm({
      firstname: "",
      lastname: "",
      useremail: "",
      phone_number: "",
      organization_code: "",
      language_id: "",
      scored_date: "",
      report_name: "",
      is_active: "",
    });
    fetchParticipantsListData();
    setScoreDate();
    SetItemData();
  };

  return (
    <React.Fragment>
      <Modal
        className="batches-modal-add"
        isOpen={modal}
        toggle={() => {
          toggle();
          onResetFormData();
          setScoreDate();
        }}
      >
        <ModalHeader
          tag="h4"
          toggle={() => {
            toggle();
            onResetFormData();
            setScoreDate();
          }}
        >
          {!!isEdit
            ? props.t("Edit Participants")
            : props.t("Add Participants")}
        </ModalHeader>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="flex-form-batches">
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("First Name")}:
                </Label>
                <Input
                  name="firstname"
                  className="form-control"
                  placeholder={props.t("Enter First Name")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.firstname || ""}
                  invalid={
                    validation.touched.firstname && validation.errors.firstname
                      ? true
                      : false
                  }
                />
                {validation.touched.firstname && validation.errors.firstname ? (
                  <FormFeedback type="invalid">
                    {validation.errors.firstname}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Last Name")}:
                </Label>
                <Input
                  name="lastname"
                  className="form-control"
                  placeholder={props.t("Enter Last Name")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.lastname || ""}
                  invalid={
                    validation.touched.lastname && validation.errors.lastname
                      ? true
                      : false
                  }
                />
                {validation.touched.lastname && validation.errors.lastname ? (
                  <FormFeedback type="invalid">
                    {validation.errors.lastname}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("User Mail")}:
                </Label>
                <Input
                  name="useremail"
                  className="form-control"
                  placeholder={props.t("Enter User Mail")}
                  type="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.useremail || ""}
                  invalid={
                    validation.touched.useremail && validation.errors.useremail
                      ? true
                      : false
                  }
                />
                {validation.touched.useremail && validation.errors.useremail ? (
                  <FormFeedback type="invalid">
                    {validation.errors.useremail}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Phone Number")}:
                </Label>
                <Input
                  name="phone_number"
                  className="form-control"
                  placeholder={props.t("Enter Phone Number")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.phone_number || ""}
                  invalid={
                    validation.touched.phone_number &&
                    validation.errors.phone_number
                      ? true
                      : false
                  }
                />
                {validation.touched.phone_number &&
                validation.errors.phone_number ? (
                  <FormFeedback type="invalid">
                    {validation.errors.phone_number}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Organisation Code")}:
                </Label>
                <Input
                  name="organization_code"
                  className="form-control"
                  placeholder={props.t("Enter Organisation Code")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.organization_code || ""}
                  invalid={
                    validation.touched.organization_code &&
                    validation.errors.organization_code
                      ? true
                      : false
                  }
                />
                {validation.touched.organization_code &&
                validation.errors.organization_code ? (
                  <FormFeedback type="invalid">
                    {validation.errors.organization_code}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Language")}:
                </Label>
                <Input
                  name="language_id"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.language_id || ""}
                  invalid={
                    validation.touched.language_id &&
                    validation.errors.language_id
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Language")}</option> */}
                  {languageList?.map((data, key) => {
                    return (
                      <option key={key} value={data?.id}>
                        {data?.label}
                      </option>
                    );
                  })}
                </Input>
                {validation.touched.language_id &&
                validation.errors.language_id ? (
                  <FormFeedback type="invalid">
                    {validation.errors.language_id}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Score Date")}:
                </Label>
             
                <DatePicker
                  name="scored_date"
                  className="form-control d-block"
                  selected={scoreDate?scoreDate:localDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  scrollableYearDropdown
                  yearDropdownItemNumber={201} // Set the number of years to show (this doesn't actually limit it)
                 // Make the year dropdown scrollable
                  // Custom year dropdown to display years from 1900 to 2100
                  yearDropdownItems={Array.from({ length: 201 }, (v, k) => k + 1900)}
                  placeholderText="YYYY-MM-DD"
                  onChange={(date) => {

                    setScoreDate(date)}}
                  dateFormat="dd-MM-yyyy"
                />
                {/* <Flatpickr
                  name="scored_date"
                  className="form-control d-block"
                  placeholder="dd-mm-yyyy"
                  options={{
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "d-m-Y",
                    time_24hr: true,
                  }}
                  value={scoreDate ? new Date(scoreDate) : ''}  // 
                  onChange={(e) => {
                    setScoreDate(e[0]); // Store date as a Date object or ISO string
                  }}
                /> */}
                {/* <Input
                                    name="scored_date"
                                    className="form-control"
                                    placeholder={props.t("Enter Score Date")}
                                    type="date"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={(validation.values.scored_date || "").split("T")[0]}
                                    invalid={
                                        validation.touched.scored_date && validation.errors.scored_date ? true : false
                                    }
                                /> */}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Report Name")}:
                </Label>
                <Input
                  name="report_name"
                  className="form-control"
                  placeholder={props.t("Enter Report Name")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.report_name || ""}
                  invalid={
                    validation.touched.report_name &&
                    validation.errors.report_name
                      ? true
                      : false
                  }
                />
                {validation.touched.report_name &&
                validation.errors.report_name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.report_name}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Password")}:
                </Label>
                <Input
                  name="password"
                  className="form-control"
                  placeholder={props.t("Enter Password")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.password || ""}
                  invalid={
                    validation.touched.password && validation.errors.password
                      ? true
                      : false
                  }
                />
                {validation.touched.password && validation.errors.password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.password}
                  </FormFeedback>
                ) : null}
              </div>
            </div>

            <div className="mb-3 d-flex align-items-center gap-3">
              <Label className="form-label m-0">{props.t("Status")}:</Label>
              <div className="d-flex align-items-center gap-2">
                <Input
                  id="active"
                  name="is_active"
                  type="radio"
                  checked={validation.values.is_active == "Y" ? true : false}
                  value="Y"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label className="form-label m-0" for="active">
                  {props.t("Active")}
                </Label>
                <Input
                  id="inactive"
                  name="is_active"
                  checked={validation.values.is_active === "N" ? true : false}
                  value="N"
                  type="radio"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label for="inactive" className="form-label m-0">
                  {props.t("In-Active")}
                </Label>
              </div>
              {validation.touched.is_active && validation.errors.is_active ? (
                <FormFeedback type="invalid">
                  {validation.errors.is_active}
                </FormFeedback>
              ) : null}
            </div>

            {editLoading ? (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-block d-flex"
                  disabled
                >
                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                  {props.t("Submit")}
                </button>
              </div>
            ) : (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                  // disabled
                >
                  {props.t("Submit")}
                </button>
              </div>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

ParticipantsAddEditModal.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(ParticipantsAddEditModal);
